import React from 'react';
import classes from './Pricing.module.css';

const Pricing = () => {
    return (
        <>
            <div className={classes.pricing__container}>
                <div className={classes.pricing__left} />
                <article className={classes.pricing__right}>
                    <h3 className={classes.pricing__subtitle}>What's New</h3>
                    <h2 className={classes.pricing__title}>
                        <span className={classes.pricing__important_text}>What's new</span> for the learners!
                    </h2>
                    <p className={classes.pricing__content}>
                        <span className={classes.pricing__strong_text}>
                        Special Offline weekly classes provides you the feel of group study like environment.
                        </span>
                    </p>
                    <p className={classes.pricing__content}>
                        <span className={classes.pricing__strong_text}>
                        Also available at your premises, this reduces the travel hassle.
                        </span>
                    </p>
                    <p className={classes.pricing__content}>
                        <span className={classes.pricing__strong_text}>
                        Project oriented learning
                        </span>
                    </p>
                    <p className={classes.pricing__content}>
                        <span className={classes.pricing__strong_text}>
                            Focuses more on practical knowledge.
                        </span>
                    </p>
                    <p className={classes.pricing__content}>
                        <span className={classes.pricing__strong_text}>
                            No hard and fast course deadline depends upon the groups ability to digest knowledge.
                        </span>
                    </p>
                    
                    <h2 className={`${classes.pricing__title} ${classes.large_top_margin}`}>
                        But for now, only online class are available,{' '}
                        <span className={classes.pricing__strong_text}>feel free</span>{' '}
                        <span className={classes.pricing__important_text}>So test away!</span>
                    </h2>
                    {/* <div className={classes.pricing__btnSection}>
                        <a href='#hero' className={classes.pricing__btn}>
                            SIGN UP FOR FREE
                        </a>
                    </div> */}
                </article>
            </div>
            <div className={classes.pricing__background}>
                <figure className={classes.pricing__figure}>
                    <img alt='Tech study group' src='Daco_107434.png' />
                </figure>
            </div>
        </>
    );
};

export default Pricing;
